import { FilterCheckbox } from '@direct-frontend/components';
import { type Filter } from '@adv-frontend/filters';

type CheckboxFilterProps = {
    id: string;
    title: string;
    defaultValue?: boolean;
};

export const createCheckboxFilter = (props: CheckboxFilterProps): Filter<string, 'true' | 'false'> => {
    const { id, title, defaultValue } = props;

    return {
        id,
        title,
        reconcile: ({ value }) => {
            return { value: value.includes('true') ? 'true' : 'false' };
        },

        validate: () => null,
        hasValue: ({ value }) => value === 'true' || value === 'false',

        getDefaultValue: () => {
            return { value: defaultValue === false ? 'false' : 'true' };
        },

        render: (props) => (
            <FilterCheckbox
                {...props}
                onChange={(isSelected: boolean) => {
                    props.onChange({ value: isSelected ? 'true' : 'false' });
                }}
                size="xs"
                color="contour"
                title={title}
                isSelected={props.value === 'true'}
            />
        ),
    };
};
